<template>
  <h2 class="content_title" :style="{ width: width + 'px' }">{{ title }}</h2>
</template>

<script>
export default {
  props: ['title', 'width']
}
</script>

<style lang="css" scoped>
.content_title {
  background-color: #4FCCD4;
  border-radius: 0 100px 100px 0;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SectionTitle.vue